<template>
    <div>
        <h3 class=" mb-3">{{ $t('student-details') }}</h3>

        <TextInput
            v-model="student.student_id_number"
            :label="$t('student-id-number')"
        />

        <TextInput
            v-model="student.hospital_resource_number"
            :label="$t('hospital-resource-no')"
        />

        <SelectInput
            v-model="student.programme_id"
            :options="$config.getValue('programmes')"
            :label="$t('programme')"
            optionLabel="Name"
            optionValue="Id"
        />

        <SelectInput
            v-model="student.year"
            :options="$config.getProgrammeYears(value.programme_id, true)"
            :label="$t('year')"
            :labelCb="year => $config.getYearStr(year, value.programme_id)"
        />

        <SelectInput
            v-model="student.group_id"
            :options="$config.getValue('groups')"
            :indexIsValue="true"
            :label="$t('group')"
        />

        <SelectInput
            v-model="student.firm_id"
            :options="$config.getValue('firms')"
            :indexIsValue="true"
            :label="$t('firm')"
        />

        <SelectInput
            v-model="student.year_left"
            :options="lastTwentyYears"
            :label="$t('year-left')"
        />

        <SelectInput
            v-model="student.school_year_left"
            :options="$config.getProgrammeYears(value.programme_id, true)"
            :label="$t('school-year-left')"
            :labelCb="year => $config.getYearStr(year, value.programme_id)"
        />
    </div>
</template>

<script>

export default {
    props: {
        value: {
            type: Object,
            default: () => { return {} }
        },
    },
    mounted() {
        this.student = this.value
    },
    data() {
        return {
            student: {}
        }
    },
    computed: {
        lastTwentyYears() {
            const years = []
            const thisYear = (new Date()).getFullYear()

            for (let i = thisYear; i >= thisYear - 20; i--) years.push(i)

            return years
        },
    },
    watch: {
        student: {
            handler (newValue) {
                const programme = this.$config.getProgrammeById(newValue.programme_id)

                if (parseInt(newValue.year) > parseInt(programme.CourseLengthYears) + 1) newValue.year = 1

                this.$emit('input', newValue)
            },
            deep: true,
        }
    },
}
</script>
